import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

/**
 * WorkRoute - Collection of sites and assigned mechanics
 * Replaces the old "Route" text field system
 *
 * Collection path: companies/{companyId}/workRoutes/{routeId}
 */
export const WorkRoute = z.object({
  routeId: z.string(),
  companyId: z.string(),
  name: z.string(),
  description: z.string().optional(),

  // Mechanics assigned to this route
  assignedMechanicIds: z.array(z.string()).default([]),

  // Sites in this route
  siteIds: z.array(z.string()).default([]),

  // Schedule configuration (future feature)
  schedule: z
    .object({
      dayOfWeek: z.array(z.number()).optional(), // [0-6] for Sun-Sat
      frequency: z.enum(['daily', 'weekly', 'biweekly', 'monthly']).optional(),
    })
    .optional(),

  // UI and status
  active: z.boolean().default(true),
  color: z.string().optional(), // Hex color for UI visualization

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,
})

export type WorkRoute = z.infer<typeof WorkRoute>
